// @flow
import axios from "axios";
import { post } from "./common";

export const logErrors = async(payload: {}) => {
  try {
    await axios.post('/client/logger/error', payload);
  } catch (error) {
    // console.error(error);
    throw error;
  }
};

export const logEvent = async(payload: {event_name: string, logs: string}) => {
  try {
    await post('/customer/app/captureEventLog', payload);
  } catch (error) {
    // console.error(error);
    throw error;
  }
};

export const logUserEvent = async(payload: {event_name: string, logs: {[key: string]: string | number}}) => {
  try {
    await axios.post('/client/logger/events', payload);
  } catch (error) {
    // console.error(error);
    throw error;
  }
};